import { PageTemplateSectionSource } from 'api/custom-section/types';
import { useCallback, useState } from 'react';
import { CloseCompanyPageDerivedSectionSourcesUpdater } from '../../../../types';
import { CompanyPageSourceDerivedSectionComponentProps } from '../types';

interface Props extends CompanyPageSourceDerivedSectionComponentProps {
  onConfigurationChange: (configuration: {
    sourcePageTemplateSections: PageTemplateSectionSource[];
  }) => void;
}
export const useSourcesUpdaterState = ({
  companyPageDerivedSectionSourcesUpdater: derivedSectionSourcesUpdater,
  getPos,
  editor,
  onConfigurationChange,
}: Props) => {
  const [sourcesUpdateInProgress, setSourcesUpdateInProgress] = useState(false);
  const [closeUpdater, setCloseUpdater] =
    useState<CloseCompanyPageDerivedSectionSourcesUpdater | null>(null);
  const hasSourcePageTemplateSectionsUpdater = !!derivedSectionSourcesUpdater;
  const invokeSourcePageTemplateSectionsUpdater = useCallback(
    (latestNode) => {
      if (derivedSectionSourcesUpdater) {
        const nodePos = getPos();

        if (nodePos !== null && nodePos !== undefined) {
          setSourcesUpdateInProgress(true);

          const closeUpdater = derivedSectionSourcesUpdater({
            node: latestNode,
            nodePosition: nodePos,
            onUpdate: (sections) => {
              onConfigurationChange({
                sourcePageTemplateSections: sections,
              });
              setSourcesUpdateInProgress(false);
            },
            onCancel: () => {
              setSourcesUpdateInProgress(false);
            },
            editor,
          });

          setCloseUpdater(() => closeUpdater);
        }
      }
    },
    [derivedSectionSourcesUpdater, getPos, editor, onConfigurationChange],
  );
  const closePendingUpdater = useCallback(() => {
    if (closeUpdater) {
      closeUpdater();
      setCloseUpdater(() => null);
    }
  }, [closeUpdater]);

  return {
    hasSourcePageTemplateSectionsUpdater,
    invokeSourcePageTemplateSectionsUpdater,
    sourcesUpdateInProgress,
    closePendingUpdater,
  };
};
